<template>
  <a
    @click="this.$refs.popup.show()"
    href="javascript:"
    class="action d-inline-flex d-flex_middle text-primary fs-14 fw-medium link px-20 py-8 border-primary bg-third radius-sm hover-primary-hover fs-md-12 px-md-4 py-md-2"
  >
    {{ title }}
  </a>
  <PopupDefault ref="popup" breakpoint="lg" :title="title" :picture="picture">
    <span v-html="text"></span>
  </PopupDefault>
</template>

<script>
import PopupDefault from "../Popups/PopupDefault.vue";

export default {
  name: "Action",
  components: {
    PopupDefault,
  },
  props: {
    title: {
      type: String,
      default: "-3% при оплате онлайн",
    },
    picture: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "Описание отсутствует",
    },
    id: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
@import "./action.scss";
</style>
